import { css } from "styled-components";
export const MOUSE_INTENT = `[data-whatintent="mouse"]`;
export const KEYBOARD_INTENT = `[data-whatintent="keyboard"]`;
export const TOUCH_INTENT = `[data-whatintent="touch"]`;
// Applies the provided styles when hovered (mouse interaction) or focused (keyboard interaction)
export const onHover = (styles, { selector, includeKeyboardFocus = true, includeTouchFocus = false, includeActive = false, includeFocusWithin = false } = {}) => {
    const baseSelector = typeof selector === "string" ? `& ${selector}` : "&";
    const selectors = [
        includeActive && `${baseSelector}:active`,
        includeKeyboardFocus && `${KEYBOARD_INTENT} ${baseSelector}:focus`,
        includeTouchFocus && `${TOUCH_INTENT} ${baseSelector}:focus`,
        includeFocusWithin && `${baseSelector}:focus-within`,
        `${MOUSE_INTENT} ${baseSelector}:hover`
    ].filter(Boolean);
    return css `
    &:not(:disabled, [aria-disabled="true"]) {
      ${selectors.join(",\n")} {
        ${styles}
      }
    }
  `;
};
